import "./Table.css"
var DeveloperPortalUnidentifiedCompaniesRow = function(props){
    var date = new Date(props.timestamp * 1000)
    return <div title={unescape(props.description)} className="c_developerportal_companies_row row">
        <div className="col-md-2">{props.serialid}</div>
        <div className="col-md-5">{unescape(props.company)}</div>
        <div className="col-md-5">{date.getDate() + "/" + (date.getMonth() + 1) + " at " + date.getHours() + ":" + date.getMinutes()}</div>
    </div>
}
export default DeveloperPortalUnidentifiedCompaniesRow